<template>
  <UiButton
    variant="ghost"
    class="px-2"
    aria-label="lang"
  >
    <label for="locale-switch">
      <select
        v-model="locale"
        class="bg-transparent text-sm text-gray-800 dark:text-white appearance-none"
        @change="changeLanguage(locale)"
      >
        <option value="en-US">
          <span class="ml-2">English</span>
        </option>

        <option value="pt-BR">
          <span class="ml-2">Português</span>
        </option>
      </select>
    </label>
  </UiButton>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { LanguageIcon } from '@heroicons/vue/24/solid';
import UiButton from '@/components/ui/UiButton.vue';

const { t, locale } = useI18n();

// Methods
const changeLanguage = (lang: string) => {
  localStorage.setItem('user-locale', lang);
  locale.value = lang;
};

// Lifecycle
onMounted(() => {
  const saved = localStorage.getItem('user-locale');
  if (saved) locale.value = saved;
});
</script>
